import React from 'react';
import _ from 'lodash';

import PetHOC from '../PetHOC';

class ComingSoon extends PetHOC {
	constructor(props) {
		super(props);
		this.actions = {
			idle: [
				{
					name: 'shake',
					actions: ['isShaking'],
					start: {
						timeout: null,
						interval: () => _.random(1000, 3000),
					},
					stop: {
						timeout: null,
						interval: () => 999,
					},
				},
			],
			pet: [],
		};
	}

	render() {
		return (
			<div className="pet-wrapper">
				<div
					className={this.getClassNames()}
					onMouseEnter={this.startBeingPet}
					onMouseLeave={this.stopBeingPet}>

					<img className="pet-frame" src={this.getFrameImagePathname()} alt="" />
					<div className="pet-name">{this.getName()}</div>
					<svg className="pet-shadow" viewBox="0 0 480 480">
						<ellipse cx="254" cy="366" rx="167" ry="33" />
					</svg>

					<div className="special-pet-transform-wrapper">
						<svg viewBox="0 0 480 480">
							<g className="egg">
								<path className="fill" d="M254,369.9c40.4,0,73.2-25.3,73.2-72.1s-38.4-97.4-73.2-97.4s-73.2,50.6-73.2,97.4S213.6,369.9,254,369.9z" />
								<path className="fill--text" d="M222,298.3c-0.9,0.8-1.8,1.4-2.9,1.9c-1.1,0.5-2.3,0.7-3.7,0.7c-1.6,0-3.1-0.3-4.4-0.8
									c-1.3-0.5-2.4-1.2-3.3-2.2c-0.9-0.9-1.6-2-2.1-3.2s-0.7-2.6-0.7-4c0-1.4,0.2-2.8,0.7-4c0.5-1.2,1.2-2.3,2.1-3.3
									c0.9-0.9,2-1.7,3.3-2.2c1.3-0.5,2.7-0.8,4.3-0.8c1.5,0,2.8,0.2,3.9,0.7c1.1,0.4,2,1,2.8,1.7l-2.8,3.6c-0.4-0.3-0.9-0.7-1.5-1
									c-0.6-0.3-1.4-0.5-2.3-0.5c-0.9,0-1.7,0.2-2.3,0.5s-1.3,0.7-1.7,1.2c-0.5,0.5-0.8,1.1-1.1,1.8s-0.4,1.5-0.4,2.3
									c0,0.8,0.1,1.6,0.4,2.3c0.3,0.7,0.6,1.3,1.1,1.8s1.1,0.9,1.7,1.2c0.7,0.3,1.4,0.4,2.3,0.4c0.8,0,1.6-0.2,2.2-0.5
									c0.6-0.3,1.1-0.6,1.6-1L222,298.3z" />
								<path className="fill--text" d="M222.8,292.9c0-1.1,0.2-2.1,0.6-3.1c0.4-1,0.9-1.8,1.7-2.5c0.7-0.7,1.6-1.3,2.5-1.7s2-0.6,3.2-0.6
									c1.3,0,2.4,0.2,3.4,0.6c1,0.4,1.8,1,2.5,1.7c0.7,0.7,1.2,1.5,1.6,2.5c0.4,1,0.6,2,0.6,3.1c0,1.1-0.2,2.2-0.6,3.1
									c-0.4,1-0.9,1.8-1.6,2.5c-0.7,0.7-1.6,1.3-2.5,1.7c-1,0.4-2.1,0.6-3.3,0.6c-1.2,0-2.3-0.2-3.3-0.6s-1.8-1-2.5-1.7
									c-0.7-0.7-1.2-1.5-1.6-2.5C223,295,222.8,294,222.8,292.9z M227.4,292.8c0,0.5,0.1,1,0.3,1.5c0.2,0.5,0.4,0.9,0.7,1.2
									c0.3,0.3,0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.3,1.4,0.3c0.5,0,1-0.1,1.4-0.3c0.4-0.2,0.8-0.5,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.2
									c0.2-0.5,0.2-1,0.2-1.5s-0.1-1-0.3-1.5c-0.2-0.5-0.4-0.9-0.7-1.2c-0.3-0.3-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3
									c-0.6,0-1,0.1-1.5,0.3c-0.4,0.2-0.8,0.5-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.2C227.4,291.8,227.4,292.3,227.4,292.8z" />
								<path className="fill--text" d="M253.8,300.5h-4.6V291c0-0.6-0.1-1-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5
									c-0.3,0.3-0.4,0.8-0.4,1.3v9.5h-4.6v-15.3h4.6v1c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.3,0.6-0.4c0.3-0.1,0.6-0.2,0.9-0.3
									c0.4-0.1,0.8-0.1,1.3-0.1c0.9,0,1.6,0.1,2.1,0.4s1,0.6,1.4,1c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.5-0.3,0.8-0.5
									c0.3-0.1,0.7-0.3,1-0.3c0.4-0.1,0.8-0.1,1.3-0.1c1,0,1.8,0.1,2.5,0.4s1.2,0.7,1.6,1.2s0.7,1.1,0.9,1.7c0.2,0.6,0.3,1.3,0.3,2.1v10.1
									h-4.6V291c0-0.6-0.1-1-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.6,0-1,0.2-1.2,0.6c-0.3,0.4-0.4,0.8-0.4,1.3V300.5z" />
								<path className="fill--text" d="M266.7,284.6c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.6-0.8c-0.1-0.3-0.2-0.7-0.2-1
									c0-0.4,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.6-0.8c0.2-0.2,0.5-0.4,0.8-0.6s0.7-0.2,1-0.2s0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.8,0.6
									c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.2,0.2-0.5,0.4-0.8,0.6
									C267.4,284.5,267.1,284.6,266.7,284.6z M269.1,300.5h-4.6v-15.3h4.6V300.5z" />
								<path className="fill--text" d="M279.8,291c0-0.6-0.1-1-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.8-0.4,1.3v9.5h-4.6
									v-15.3h4.6v1c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.3,0.6-0.4s0.5-0.2,0.9-0.3c0.4-0.1,0.8-0.1,1.2-0.1c0.9,0,1.6,0.1,2.3,0.4
									c0.6,0.3,1.1,0.7,1.5,1.2s0.6,1.1,0.8,1.7s0.2,1.3,0.2,2.1v10.1h-4.6V291z" />
								<path className="fill--text" d="M298.6,285.2h4.3v12.8c0,1.4-0.2,2.6-0.6,3.6c-0.4,1-1,1.8-1.7,2.4c-0.7,0.6-1.6,1.1-2.6,1.3
									c-1,0.3-2.2,0.4-3.4,0.4c-1.1,0-2.2-0.1-3.1-0.4c-0.9-0.3-1.7-0.5-2.4-0.9l1.4-3.6c0.4,0.2,1,0.4,1.8,0.6c0.7,0.2,1.5,0.3,2.4,0.3
									c1,0,1.9-0.2,2.6-0.6c0.7-0.4,1.1-0.9,1.1-1.7c-0.3,0.3-0.8,0.6-1.4,0.8c-0.6,0.2-1.3,0.4-2.3,0.4c-1.2,0-2.3-0.2-3.3-0.6
									c-1-0.4-1.8-0.9-2.5-1.6c-0.7-0.7-1.2-1.5-1.6-2.5c-0.4-1-0.6-2-0.6-3.2c0-1.1,0.2-2.1,0.6-3.1s0.9-1.8,1.6-2.5
									c0.7-0.7,1.5-1.3,2.5-1.7c1-0.4,2-0.6,3.2-0.6c1.7,0,3.1,0.4,4.1,1.2V285.2z M291.3,292.8c0,0.5,0.1,1,0.3,1.5
									c0.2,0.5,0.4,0.9,0.7,1.2s0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.3,1.5,0.3c0.6,0,1.1-0.1,1.5-0.3s0.8-0.5,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.2
									c0.2-0.5,0.2-0.9,0.2-1.5c0-0.5-0.1-1-0.3-1.5c-0.2-0.5-0.4-0.9-0.7-1.2s-0.7-0.6-1.1-0.8s-0.9-0.3-1.5-0.3c-0.6,0-1.1,0.1-1.5,0.3
									c-0.4,0.2-0.8,0.5-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.2S291.3,292.3,291.3,292.8z" />
								<path className="fill--text" d="M226.7,314.5c0,0.4,0.1,0.8,0.4,1.1c0.3,0.3,0.7,0.6,1.4,0.8l2.5,1c1.3,0.5,2.3,1.2,3,2.1
									c0.7,0.9,1.1,2.1,1.1,3.6c0,1-0.2,1.9-0.5,2.7c-0.3,0.8-0.8,1.4-1.4,2c-0.6,0.5-1.3,1-2.2,1.2s-1.8,0.4-2.7,0.4
									c-1.4,0-2.6-0.2-3.4-0.6c-0.9-0.4-1.5-0.9-2-1.6c-0.5-0.6-0.8-1.4-0.9-2.1c-0.1-0.8-0.2-1.5-0.2-2.2h4.5c0,0.3,0,0.6,0.1,0.9
									c0.1,0.3,0.2,0.5,0.3,0.8c0.2,0.2,0.4,0.4,0.6,0.5s0.6,0.2,1,0.2c0.6,0,1-0.1,1.4-0.4c0.4-0.3,0.5-0.7,0.5-1.3c0-0.5-0.2-1-0.6-1.3
									c-0.4-0.3-0.9-0.6-1.5-0.8c-0.5-0.2-1-0.4-1.5-0.6c-0.5-0.2-1-0.4-1.6-0.7c-1-0.5-1.8-1.2-2.3-2.2c-0.5-0.9-0.8-2-0.8-3.2
									c0-0.9,0.2-1.6,0.5-2.4c0.3-0.7,0.7-1.3,1.3-1.9c0.6-0.5,1.2-0.9,2-1.2c0.8-0.3,1.7-0.4,2.6-0.4c1.2,0,2.1,0.2,3,0.5
									c0.8,0.3,1.5,0.7,1.9,1.3s0.8,1.2,1,2c0.2,0.8,0.3,1.6,0.2,2.4H230c0-0.6-0.1-1.1-0.4-1.5c-0.3-0.4-0.7-0.6-1.3-0.6
									c-0.6,0-1,0.1-1.2,0.4C226.8,313.8,226.7,314.1,226.7,314.5z" />
								<path className="fill--text" d="M237.1,321.5c0-1.1,0.2-2.1,0.6-3.1c0.4-1,0.9-1.8,1.7-2.5c0.7-0.7,1.6-1.3,2.5-1.7s2-0.6,3.2-0.6
									c1.3,0,2.4,0.2,3.4,0.6c1,0.4,1.8,1,2.5,1.7c0.7,0.7,1.2,1.5,1.6,2.5c0.4,1,0.6,2,0.6,3.1c0,1.1-0.2,2.2-0.6,3.1
									c-0.4,1-0.9,1.8-1.6,2.5c-0.7,0.7-1.6,1.3-2.5,1.7c-1,0.4-2.1,0.6-3.3,0.6c-1.2,0-2.3-0.2-3.3-0.6s-1.8-1-2.5-1.7
									c-0.7-0.7-1.2-1.5-1.6-2.5C237.3,323.6,237.1,322.6,237.1,321.5z M241.7,321.4c0,0.5,0.1,1,0.3,1.5c0.2,0.5,0.4,0.9,0.7,1.2
									c0.3,0.3,0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.3,1.4,0.3c0.5,0,1-0.1,1.4-0.3c0.4-0.2,0.8-0.5,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.2
									c0.2-0.5,0.2-1,0.2-1.5s-0.1-1-0.3-1.5c-0.2-0.5-0.4-0.9-0.7-1.2c-0.3-0.3-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3
									c-0.6,0-1,0.1-1.5,0.3c-0.4,0.2-0.8,0.5-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.2C241.8,320.4,241.7,320.9,241.7,321.4z" />
								<path className="fill--text" d="M255.1,321.5c0-1.1,0.2-2.1,0.6-3.1c0.4-1,0.9-1.8,1.7-2.5c0.7-0.7,1.6-1.3,2.5-1.7s2-0.6,3.2-0.6
									c1.3,0,2.4,0.2,3.4,0.6c1,0.4,1.8,1,2.5,1.7c0.7,0.7,1.2,1.5,1.6,2.5c0.4,1,0.6,2,0.6,3.1c0,1.1-0.2,2.2-0.6,3.1
									c-0.4,1-0.9,1.8-1.6,2.5c-0.7,0.7-1.6,1.3-2.5,1.7c-1,0.4-2.1,0.6-3.3,0.6c-1.2,0-2.3-0.2-3.3-0.6s-1.8-1-2.5-1.7
									c-0.7-0.7-1.2-1.5-1.6-2.5C255.3,323.6,255.1,322.6,255.1,321.5z M259.7,321.4c0,0.5,0.1,1,0.3,1.5c0.2,0.5,0.4,0.9,0.7,1.2
									c0.3,0.3,0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.3,1.4,0.3c0.5,0,1-0.1,1.4-0.3c0.4-0.2,0.8-0.5,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.2
									c0.2-0.5,0.2-1,0.2-1.5s-0.1-1-0.3-1.5c-0.2-0.5-0.4-0.9-0.7-1.2c-0.3-0.3-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3
									c-0.6,0-1,0.1-1.5,0.3c-0.4,0.2-0.8,0.5-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.2C259.8,320.4,259.7,320.9,259.7,321.4z" />
								<path className="fill--text" d="M281.5,319.6c0-0.6-0.1-1-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.8-0.4,1.3v9.5h-4.6
									v-15.3h4.6v1c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.3,0.6-0.4s0.5-0.2,0.9-0.3c0.4-0.1,0.8-0.1,1.2-0.1c0.9,0,1.6,0.1,2.3,0.4
									c0.6,0.3,1.1,0.7,1.5,1.2s0.6,1.1,0.8,1.7s0.2,1.3,0.2,2.1v10.1h-4.6V319.6z" />
							</g>
						</svg>
					</div>
				</div>
			</div>
		);
	}
}

export default ComingSoon;



// WEBPACK FOOTER //
// ./src/components/Global/Pet/ComingSoon/index.js